module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAABO0lEQVQokaXSv4sPcBzH8cddbpHkxyJKWFgoMlzKostwmSil7PIHmAxukBSL7QbKcFkoi0HIYJT8GJQoJQMGKUoGPA2+V1/nvufKq9716fN6f56fd71fKiNqU3V3CV9lZmbGuMU1jSeYGuH/oYWQCVzALaxZDgBWDJ234homMYsPOIM5fMMr3MazUZMcwWPswFGcxHt8woHB3Xk8xX1sXwi5hBt4gz24PvBmsQ4bsRpbcBq78QgHhyH38BHbsG/og1WDKQ7jENbjInbiNW5iF8yvanP1oN+6Uq2s9va3vlRz1VT1tnpYjQ3vfEV1tvpRPa+ODR5OVvur49Xl6vOg58XAn14sQFPVu+r7oGmhv7aaHZru6qgkbqjujIDM14nqZ/VyqUiPV6f+Eftz1dexarEQLlcTePy/EJj+BZsKcsMxFqCAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/btn _return.png
// module id = cpa6
// module chunks = 0